
const HttpRequestInterceptor = (http) => {
  http.interceptors.request.use((config) => {

    return config;
  }, console.log);
};

export default HttpRequestInterceptor;
